<div class="input-group">
  <div class="custom-file">
    <input type="file" class="custom-file-input" id="inputGroupFile01" accept="{{ _filesAccepted }}"
      aria-describedby="inputGroupFileAddon01" [placeholder]="placeholder | translate" [id]="id" [readonly]="readonly"
      value="'TEST'" (click)="$event.target.value = null" (change)="readFile($event)">
    <label class="custom-file-label" for="inputGroupFile01">{{ fileName ? fileName : 'base.lbl_choose_file' | translate }}</label>
  </div>
</div>